import { PlainButton, TextInput } from "@jugl-web/ui-components/cross-platform";
import { useTranslations } from "@jugl-web/utils";
import { ReactComponent as CloseIcon } from "./assets/close.svg";
import { MAX_VALUE_LENGTH } from "./constants";

interface CustomFieldProps {
  value: string;
  name: string;
  onChange: (value: string) => void;
  onRemove: () => void;
}

export const CustomField = ({
  value,
  name,
  onChange,
  onRemove,
}: CustomFieldProps) => {
  const { t } = useTranslations();

  const handleChange = (newValue: string) => {
    if (newValue.length <= MAX_VALUE_LENGTH) {
      onChange(newValue);
    }
  };

  return (
    <div className="flex items-center gap-2">
      <div className="w-full">
        <TextInput
          placeholder={t({
            id: "common.enter",
            defaultMessage: "Enter",
          })}
          label={name}
          value={value}
          onChange={(e) => handleChange(e.target.value)}
          errorMessage={
            value.length > MAX_VALUE_LENGTH
              ? t({
                  id: "invoices.settings.businessInformation.customField.maxLength",
                  defaultMessage: `Field value must be ${MAX_VALUE_LENGTH} characters or fewer`,
                })
              : undefined
          }
        />
      </div>

      <PlainButton className="mt-7" onClick={onRemove}>
        <CloseIcon />
      </PlainButton>
    </div>
  );
};
